function storefrontObserverService() {

    let listSubscribers = [];
    return {
        subscribe(fn) {
            listSubscribers.push(fn);
        },
        notify(showRefund) {
            listSubscribers.forEach(fn => fn(showRefund));
        },
        unsubscribe(fn) {
            listSubscribers = listSubscribers.filter(fnItem => fn !== fnItem)
        }
    }
}
angular.module('qkr')
    .factory('storefrontObserverService', storefrontObserverService);


// WEBPACK FOOTER //
// ./src/services/storefront.observer.service.js